import React from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import UserService from '../../services/user.service';
import { useForm } from "react-hook-form";

const UsernameEmailModal = (props) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {email: props.user.email, userId: props.user.id},
  });

  const onSubmit = async (data) => {
    await UserService.updateUsernameEmail(data);
    props.closeUsernameEmailModal(false); 
  }

  const usernameEmailModalClose = () => {
    props.closeUsernameEmailModal(false);
  }

  return (
    <Modal show={props.show} onHide={usernameEmailModalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Username / Email<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Username / Email</Form.Label>
                <input {...register('email', { 
                    required: 'Username / Email is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address'
                    }
                  })}  /><br/>
                {errors.email && <div className="error">{errors.email.message}</div>}
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={usernameEmailModalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)} type="submit">
                  Update Username and Email
                </Button>
              </Modal.Footer>
            </Form>  
    </Modal.Body>
    </Modal>
  );
};

export default UsernameEmailModal; 